module.exports = __webpack_public_path__ + "blacktea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blacktea.png
// module id = 870
// module chunks = 0